import { Domain } from "src/config/BartLambdaConfig";

export enum ModalMode {
  CREATE = "create", // Creating a new ARD from scratch
  EDIT = "edit", // Modifying an existing ARD
  DUPLICATE = "duplicate", // Creating a new ARD based on an existing one
}

export type ArdRegionMap = Map<string, Domain>;
